export default __webpack_public_path__ + "static/media/maintenance.00eaa761.svg";